import {Select} from 'antd'
import React from 'react'

const BoolFilter = ({onChange, filter}) => (
  <Select
    onChange={value => onChange(value)}
    style={{width: '100%'}}
    value={filter ? filter.value : 'all'}>
    <Select.Option value="all">All</Select.Option>
    <Select.Option value={true}>Yes</Select.Option>
    <Select.Option value={false}>No</Select.Option>
  </Select>
)

export default BoolFilter
